<div class="main-container">
    <div class="container-fluid pt-3 mb-3 pb-3">
        <div class="login">
            <div class="login-section">
                <div class="login-form text-center">
                <mat-icon class="text-success">check_circle</mat-icon>
                <h2 class="">Logged Out</h2>
                <p class="">Click here to <span class="" routerLink="/auth/login">Login</span> again</p>
            </div>
            </div>
        </div>
    </div>
  </div>

